import { render, staticRenderFns } from "./gjxx1.vue?vue&type=template&id=027fdc8e&scoped=true&"
import script from "./gjxx1.vue?vue&type=script&lang=js&"
export * from "./gjxx1.vue?vue&type=script&lang=js&"
import style0 from "./gjxx1.vue?vue&type=style&index=0&id=027fdc8e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "027fdc8e",
  null
  
)

export default component.exports